import React from "react";
import ProviderRegistration from "../../components/forms/provider/ProviderRegistration";
import "./providerPage.css"

const ProviderPage = () => {
  return (

    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-12">
          <div class="card-layout">
            {/* <div className="card-body"> */}
              <ProviderRegistration />
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProviderPage;
